/* Searchmind CRO-udkast til produktsiden */
(function () {
  'use strict';
  function money(c) {
    try { if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(c, theme.settings.moneyFormat); } catch (e) {}
    return (c / 100).toFixed(2).replace('.', ',') + ' kr';
  }
  function data(root) {
    if (root._croData !== undefined) return root._croData;
    var el = root.querySelector('script[data-cro-data]');
    try { root._croData = el ? JSON.parse(el.textContent) : null; } catch (e) { root._croData = null; }
    return root._croData;
  }
  function fill(tpl, v) {
    var s = (tpl || '').replace(/\[antal\]/g, v.q);
    if (!v.s) s = s.replace(/ i str\. \[str\]/g, '');
    return s.replace(/\[str\]/g, v.s || '');
  }
  function update(root, id) {
    var d = data(root); if (!d) return;
    var v = d.variants[String(id)];
    root.querySelectorAll('[data-cro-stock]').forEach(function (el) {
      if (!v || !v.a) { el.hidden = true; return; }
      var thr = parseInt(el.getAttribute('data-threshold'), 10) || 0;
      var low = v.t && !v.c && v.q > 0 && v.q <= thr;
      el.hidden = false; el.classList.toggle('cro-stock--low', low);
      el.querySelector('[data-cro-stock-text]').textContent = fill(low ? el.getAttribute('data-low') : el.getAttribute('data-ok'), v);
    });
    root.querySelectorAll('[data-cro-btn-price]').forEach(function (el) {
      if (!v || !v.a) { el.hidden = true; return; }
      el.hidden = false; el.textContent = '· ' + money(v.p);
    });
    if (v) root.querySelectorAll('[data-cro-shipping]').forEach(function (el) {
      el.innerHTML = v.p >= d.threshold ? el.getAttribute('data-free') : el.getAttribute('data-paid');
    });
    var st = root._croSticky || root.querySelector('[data-cro-sticky]');
    if (st) {
      st.querySelector('[data-cro-sticky-title]').textContent = st.getAttribute('data-title') + (v && v.s ? ' · str. ' + v.s : '');
      if (v) {
        st.querySelector('[data-cro-sticky-price]').textContent = money(v.p);
        st.querySelector('[data-cro-sticky-ship]').textContent = v.p >= d.threshold ? ' · ' + st.getAttribute('data-free-label') : '';
      }
      var btn = st.querySelector('[data-cro-sticky-btn]'), ok = !!(v && v.a);
      btn.disabled = !ok; btn.textContent = ok ? st.getAttribute('data-add-label') : st.getAttribute('data-sold-label');
    }
  }

  /* Nedtælling til dagens afsendelse */
  var DAYS = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }, DAY_MS = 86400000;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hms(s) { return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60); }
  function nowCph() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, wd: DAYS[p.weekday], sec: (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second) };
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  function isClosed(n, extra) {
    var md = pad(n.m) + '-' + pad(n.d);
    if (md === '01-01' || md === '12-25' || md === '12-26') return true;
    if (extra.indexOf(md) > -1 || extra.indexOf(n.y + '-' + md) > -1) return true;
    var t = Date.UTC(n.y, n.m - 1, n.d), e = easter(n.y);
    return [-3, -2, 0, 1, 39, 49, 50].some(function (o) { return t === e + o * DAY_MS; });
  }
  function tickDelivery() {
    var els = document.querySelectorAll('[data-cro-dispatch]'); if (!els.length) return;
    var n; try { n = nowCph(); } catch (e) { return; }
    els.forEach(function (el) {
      var cut = (parseFloat(el.getAttribute('data-cutoff')) || 12) * 3600;
      var extra = (el.getAttribute('data-closed') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (n.wd <= 5 && n.sec < cut && !isClosed(n, extra)) {
        el.innerHTML = (el.getAttribute('data-tpl-countdown') || '').replace('[tid]', '<span class="cro-cd">' + hms(cut - n.sec) + '</span>').replace('[dag]', 'i dag') + ' ';
      } else if (el.innerHTML !== '') { el.innerHTML = ''; }
    });
  }

  /* Anyday-vinduet åbnes via Anydays egen (skjulte) widget */
  function openAnyday() {
    var ws = document.querySelectorAll('anyday-price-widget');
    for (var i = 0; i < ws.length; i++) {
      var c = ws[i].shadowRoot && ws[i].shadowRoot.querySelector('.anyday-clickable');
      if (c) { c.click(); return true; }
    }
    return false;
  }
  /* Chatten (Shoply AI-assistent) */
  function openChat() {
    var h = document.getElementById('floating-shopping-assistant');
    var b = h && h.shadowRoot && h.shadowRoot.querySelector('button[aria-label="Open chat"]');
    if (b) { b.click(); return true; }
    window.location.href = 'mailto:kundeservice@qnts.dk';
    return false;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cro-anyday]')) { e.preventDefault(); openAnyday(); }
    else if (e.target.closest('[data-cro-open-chat]')) { e.preventDefault(); openChat(); }
  });

  /* Produktbeskrivelse foldet sammen med "Læs mere" */
  function initDesc(root) {
    var d = root.querySelector('#cro-beskrivelse'); if (!d || d._croInit) return;
    var rte = d.querySelector('.rte'); if (!rte) return;
    d._croInit = true;
    if (rte.scrollHeight <= 260) return;
    rte.classList.add('cro-rte', 'is-collapsed');
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cro-more'; b.textContent = 'Læs mere'; b.setAttribute('aria-expanded', 'false');
    rte.parentNode.insertBefore(b, rte.nextSibling);
    b.addEventListener('click', function () {
      var c = rte.classList.toggle('is-collapsed');
      b.textContent = c ? 'Læs mere' : 'Vis mindre'; b.setAttribute('aria-expanded', String(!c));
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-cro-gallery]').forEach(function (g) {
      if (g._croInit) return; g._croInit = true;
      var main = g.querySelector('[data-cro-main]');
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cro-thumb]'); if (!b || !main) return;
        main.src = b.getAttribute('data-src'); main.alt = b.getAttribute('data-alt');
        g.querySelectorAll('[data-cro-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
  }
  function initSticky(root) {
    var st = root.querySelector('[data-cro-sticky]'); if (!st || st._croInit) return; st._croInit = true;
    var form = document.getElementById(st.getAttribute('data-form'));
    var main = form && form.querySelector('[data-add-to-cart]');
    if (!main || !('IntersectionObserver' in window)) { st.parentNode.removeChild(st); return; }
    root._croSticky = st; document.body.appendChild(st); document.body.classList.add('cro-has-sticky');
    var btn = st.querySelector('[data-cro-sticky-btn]');
    function show(on) { st.classList.toggle('is-visible', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); btn.tabIndex = on ? 0 : -1; }
    show(false);
    new IntersectionObserver(function (en) { var e = en[0]; show(!e.isIntersecting && e.boundingClientRect.top < 0); }).observe(main);
    btn.addEventListener('click', function () { if (!main.disabled) main.click(); });
  }
  function init() {
    document.querySelectorAll('[data-cro-root]').forEach(function (r) { initGallery(r); initSticky(r); initDesc(r); });
    tickDelivery();
  }
  document.addEventListener('variant:change', function (evt) {
    var v = evt.detail && evt.detail.variant; if (!v) return;
    document.querySelectorAll('[data-cro-root]').forEach(function (r) { var d = data(r); if (d && d.variants[String(v.id)]) update(r, v.id); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  setInterval(tickDelivery, 1000);
})();